import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, X, ArrowRight } from 'lucide-react';
import { api } from '../api';

export const OfferBanner = () => {
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('offer-banner-dismissed') === '1');

  useEffect(() => {
    api.get('/offer-banner').then((res) => setBanner(res.data)).catch(() => {});
  }, []);

  if (!banner?.enabled || dismissed) return null;

  const go = () => {
    if (/^https?:\/\//.test(banner.cta_link)) window.open(banner.cta_link, '_blank', 'noopener');
    else navigate(banner.cta_link || '/packages');
  };

  return (
    <div data-testid="offer-banner" className="relative mt-16 bg-gradient-to-r from-amber-400 via-orange-400 to-rose-400 text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center sm:text-left">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 flex-shrink-0" />
          <p className="text-sm sm:text-base">
            <span className="font-bold" data-testid="offer-banner-title">{banner.title}</span>
            {banner.message && <span className="ml-2" data-testid="offer-banner-message">{banner.message}</span>}
          </p>
        </div>
        {banner.cta_text && (
          <button
            data-testid="offer-banner-cta"
            onClick={go}
            className="inline-flex items-center gap-1 bg-gray-900 text-white text-sm font-semibold px-4 py-1.5 rounded-full hover:bg-gray-800 transition-colors"
          >
            {banner.cta_text} <ArrowRight className="w-4 h-4" />
          </button>
        )}
      </div>
      <button
        data-testid="offer-banner-dismiss"
        onClick={() => { sessionStorage.setItem('offer-banner-dismissed', '1'); setDismissed(true); }}
        aria-label="Dismiss offer"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-black/10 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
